import { Label } from "../../ui/label";
import { Input } from "../../ui/input";
import AdvancedSection from "./AdvancedSection";

export default function PorMascotaConfig({ config, onChange }) {
  return (
    <div className="space-y-4">
      <div className="rounded-lg border border-amber-200 bg-amber-50 px-4 py-3">
        <p className="text-sm text-gray-700">
          Precio unitario × cantidad. La prima = precio del plan (de <strong>Precios Base</strong>) multiplicado por el
          atributo <code>numero_mascotas</code>. Asegúrate de activar el campo <code>numero_mascotas</code> en el tab
          "Configuración JSON" para que el cotizador lo pida.
        </p>
      </div>
      <AdvancedSection>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <Label className="text-xs text-gray-500">Precio base — Tabla</Label>
            <Input value={config?.precioBase?.tabla || ""} onChange={(e) => onChange("precioBase.tabla", e.target.value)} placeholder="precios_base" />
          </div>
          <div>
            <Label className="text-xs text-gray-500">Precio base — Campo Resultado</Label>
            <Input value={config?.precioBase?.campoResultado || ""} onChange={(e) => onChange("precioBase.campoResultado", e.target.value)} placeholder="precio_uf" />
          </div>
        </div>
      </AdvancedSection>
    </div>
  );
}
